import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

class AddSkuMessage extends Component {
  state = { bulletHeight: 0 };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const bulletHeight = document.getElementsByClassName(styles.bulletsContent)[0].clientHeight;
    this.setState({ bulletHeight });
  };

  render() {
    const { bullets } = this.props;
    const height = `${this.state.bulletHeight}px`;

    const list = bullets.map((bullet) => {
      return (
        <li key={bullet}>
          <p className="p1 n700">{bullet}</p>
        </li>
      );
    });

    return (
      <div className={styles.bulletsContainer} style={{ height }}>
        <div className={styles.bulletsContent}>
          <h4 className="paddingBottom-small">IMPORTANT:</h4>
          <ul>{list}</ul>
        </div>
      </div>
    );
  }
}

AddSkuMessage.propTypes = {
  bullets: PropTypes.array.isRequired,
};

export default AddSkuMessage;
